import React from "react";

// v-bonat 2026-06 — المكوّن المشترك الوحيد للفلاتر الديموغرافية (بونات):
// الجنس + نطاق العمر الحر + شمل من بلا بيانات. مصدر واحد يعيد استخدامه
// CampaignWizard + حملة البلاست (BlastCampaignModal) + استبيان الشريحة
// (CampaignCard) — لا نسختان تتباعدان. props: demo (كائن) · setDemo(patch) ·
// demoInfo? (إحصاء البركة الحيّ إن توفّر).
export function DemographicFilters({ demo = {}, setDemo, demoInfo }) {
  return (
    <div className="rounded-xl p-4 border-2" style={{ borderColor: "#C4B5FD", background: "#F5F3FF" }}
         data-testid="audience-demographics">
      <div className="text-sm font-bold mb-3" style={{ color: "#5B21B6" }}>
        🎯 فلاتر ديموغرافية (بيانات بونات) — اختيارية، تُدمج مع الشرائح
      </div>
      <div className="text-xs font-bold mb-1" style={{ color: "#5B21B6" }}>الجنس:</div>
      <div className="flex gap-2 flex-wrap mb-3">
        {[
          { id: "", label: "بلا فلتر" },
          { id: "male", label: "رجال" },
          { id: "female", label: "نساء" },
          { id: "unknown", label: "غير محدد" },
        ].map((g) => {
          const on = (demo.gender || "") === g.id;
          return (
            <button key={g.id || "none"} type="button"
                    data-testid={`demo-gender-${g.id || "none"}`}
                    onClick={() => setDemo({ gender: g.id })}
                    className="px-3 py-1.5 rounded-lg text-xs font-bold border-2 transition-colors"
                    style={{ borderColor: on ? "#7C3AED" : "#e5e7eb",
                             background: on ? "#EDE9FE" : "white",
                             color: on ? "#5B21B6" : "#475569" }}>
              {g.label}
            </button>
          );
        })}
      </div>
      <div className="text-xs font-bold mb-1" style={{ color: "#5B21B6" }}>نطاق العمر (حر):</div>
      <div className="flex items-center gap-2 mb-3">
        <span className="text-xs">من</span>
        <input type="number" min="0" max="120" value={demo.age_min ?? ""}
               data-testid="demo-age-min"
               onChange={(e) => setDemo({ age_min: e.target.value === "" ? null : Number(e.target.value) })}
               className="w-20 px-2 py-1 rounded border text-sm" placeholder="—" />
        <span className="text-xs">إلى</span>
        <input type="number" min="0" max="120" value={demo.age_max ?? ""}
               data-testid="demo-age-max"
               onChange={(e) => setDemo({ age_max: e.target.value === "" ? null : Number(e.target.value) })}
               className="w-20 px-2 py-1 rounded border text-sm" placeholder="—" />
        <span className="text-xs opacity-70">سنة</span>
      </div>
      {/* قرار صريح: من بلا بيانات جنس/عمر — يُشمل أم يُستبعد؟ */}
      <label className="flex items-center gap-2 cursor-pointer" data-testid="demo-include-unknown">
        <input type="checkbox" checked={!!demo.include_unknown}
               onChange={(e) => setDemo({ include_unknown: e.target.checked })} />
        <span className="text-xs font-semibold" style={{ color: "#5B21B6" }}>
          شمل العملاء بلا بيانات جنس/عمر
          {demoInfo ? ` (${(demoInfo.unknown_gender_in_pool || 0).toLocaleString("ar")} بلا جنس · ${(demoInfo.unknown_age_in_pool || 0).toLocaleString("ar")} بلا عمر)` : ""}
        </span>
      </label>
      <div className="text-[11px] mt-2 opacity-80" style={{ color: "#5B21B6" }}>
        افتراضيًا يُستبعد من لا بيانات له عند تفعيل أي فلتر — فعّل الخيار أعلاه لشمولهم صراحةً.
      </div>
    </div>
  );
}

export default DemographicFilters;
